<template>
  <master-layout v-bind:pageTitle="this.$t('login')">
    <ion-page>
      <div class="whiterow"></div>
      <ion-card class="card-center">
        <ion-card-header>
          <ion-card-title>{{ $t('login') }}</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <img
            id="profile-img"
            src="/assets/icon/default-avatar.svg"
            class="profile-img-card"
          />
          <Form
            ref="credentialform"
            @submit="handleLogin"
            @invalid-submit="handleInvalidSubmit"
            :validation-schema="schema"
          >
            <div class="form-group">
              <label for="username">{{ $t('username') }}</label>
              <Field name="username" v-slot="{ field, meta, errors }">
                <input v-bind="field" type="text" />
              </Field>
            </div>
            <div class="form-group">
              <label for="password">{{ $t('password') }}</label>
              <Field name="password" v-slot="{ field, meta, errors }">
                <input v-bind="field" type="password" />
              </Field>
            </div>

            <div class="form-actions">
              <ion-button :disabled="loading" type="submit">
                <span
                  v-show="loading"
                  class="spinner-border spinner-border-sm"
                ></span>
                <span>{{ $t('login') }}</span>
              </ion-button>
            </div>
            <div>
              <div v-if="message" class="alert alert-danger" role="alert">
                {{ message }}
              </div>
            </div>
          </Form>
        </ion-card-content>
      </ion-card>
      <div class="fwtd"><router-link :to="'/forgotpassword'">{{ $t('forgotPassword')}}</router-link></div>
    </ion-page>
  </master-layout>
</template>

<script>
import { Form, Field } from "vee-validate";
import * as yup from "yup";
import { IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonButton, IonPage} from '@ionic/vue';

export default {
  name: "Login",
  components: {
    Form,
    Field,
    IonPage,
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCardContent,
    IonButton
  },
  data() {
    const schema = yup.object().shape({
      username: yup.string().required("Username is required!"),
      password: yup.string().required("Password is required!"),
    });

    return {
      loading: false,
      message: "",
      schema,
      wasLoggedIn: false,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  created() {
    this.wasLoggedIn = this.loggedIn;
    if (this.loggedIn) {
      this.$router.push("/profile");
    }
  },
  methods: {
    handleLogin(user) {
      this.loading = true;
      this.message = "";

      this.$store.dispatch("auth/login", user).then(
        () => {
          this.loading = false;
          this.$router.push("/profile");
        },
        (error) => {
          this.loading = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },
    handleInvalidSubmit({ errors }) {
      this.loading = false;
      const messages = Object.values(errors || {});
      if (messages.length) {
        this.message = messages.join(" ");
      } else {
        this.message = "";
      }
    },
    resetLoginForm() {
      this.loading = false;
      this.message = "";
      if (this.$refs.credentialform && this.$refs.credentialform.resetForm) {
        this.$refs.credentialform.resetForm();
      }
    },
  },
  beforeUpdate() {
    // When user logs out and is redirected back to login,
    // reset the form state so that validation errors and
    // previous messages (like "Invalid Password") are cleared.
    const isLoggedIn = this.loggedIn;
    if (this.wasLoggedIn && !isLoggedIn) {
      this.resetLoginForm();
    }
    this.wasLoggedIn = isLoggedIn;
  },
};
</script>
  
<style scoped>
  label {
    display: block;
    margin-top: 10px;
  }
  .form-group {
    margin-bottom: 12px;
  }
  .form-actions {
    margin-top: 16px;
  }
  .error-feedback {
    display: block;
    color: #f44336;
    font-size: 0.9rem;
    margin-top: 4px;
  }
  .profile-img-card {
    width: 96px;
    height: 96px;
    margin: 0 auto 10px;
    display: block;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
  }
</style>